import { ResultsState } from 'enums'
import styled from 'styled-components'

import { getStatusIconColor } from 'utils/styles'

export const StateWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.size.space['04']};
  &:nth-child(1) {
    margin-top: ${({ theme }) => theme.size.space['01']};
  }
`

export const StateText = styled.div`
  color: ${({ theme }) => theme.color.base.neutral.black};
  text-transform: capitalize;
`

export const StatusIconWrapper = styled.div<{ status: ResultsState }>`
  display: flex;
  align-items: center;

  svg {
    width: ${({ theme }) => theme.size.icon.small};
    height: ${({ theme }) => theme.size.icon.small};

    path {
      fill: ${({ status, theme }) => getStatusIconColor(status, theme)};
    }
  }
`
